/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import routes from '../routes.js'
import AccountMenu from './AccountMenu'
import Navigations from './Navigations'

function staticProps(Component, props, navigations) {
  const mergeProps = Object.assign(props, { navigations: navigations, accountMenu: AccountMenu })
  return matchProps => {
    return <Component {...mergeProps} {...matchProps} />
  }
}

function MainView(props) {
  const navigations = Navigations(props.session.isOwner)
  return (
    <div className="row wrapper">
      <main className={`AppMain main`}>
        <Switch>
          {routes.map((route, index) => (
            <Route key={index} path={route.path} exact={route.exact} component={staticProps(route.view, route.props || {}, navigations)} />
          ))}
        </Switch>
      </main>
    </div>
  )
}

export default MainView
